import { render, staticRenderFns } from "./BotaoAdicionar.vue?vue&type=template&id=401e92ac&scoped=true&"
import script from "./BotaoAdicionar.vue?vue&type=script&lang=ts&"
export * from "./BotaoAdicionar.vue?vue&type=script&lang=ts&"
import style0 from "./BotaoAdicionar.vue?vue&type=style&index=0&id=401e92ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e92ac",
  null
  
)

export default component.exports